import { Product, ProductAvailability } from 'core/product/Product';

export type CreativeOfCampaign = {
  rtbCreativeId: any,
  id: number,
  name: string,
  status: CreativeStatus,
  ctr: number,
  imps: number,
  clicks: number,
  size: string,
  creativeType: CreativeType,
  approvalStatus: any,
  bannerImageUrl: string,
  creativeValue: any,
  createTime: string,
  landingPageUrl: string,
  isActiveBinding: boolean,
  tenmaxCategory: string,
  origTenmaxCategory: string | null,
  bindingState: CampaignBannerMapState,
  effectiveStatus?: string,
  issuesInfo?: string,
  l3ChannelId: string,
  report?: any,
  bannerExtra?: { [key: string]: string | number | boolean | object },
  previewLink?: string,
  retail?: string,
  product?: Product;
  relatedProductInfo?: CreativeRelatedProductInfo[];
  hasProductAuth: boolean;
};

export type Creative = {
  basic: CreativeBasic
};

export type CreativeBasic = {
  advertiserId: number,
  agencyId: number,
  bannerUrl: string,
  creativeId: number,
  creativeType: CreativeType,
  creativeState: CreativeStatus,
  creativeValues: any,
  landingPageUrl: string,
  name: string,
  tenmaxCategory: string,
  bannerExtra?: { [key: string]: string | number | boolean | object },
  bannerImageUrl?: string,
  duration?: number,
  retail?: string,
  product?: Product;
  relatedProductInfo?: CreativeRelatedProductInfo[];
};

export type BindingCampaign = {
  id: number,
  name: string,
  orderNumber: string,
  active: boolean,
  isActive: boolean
};

export enum CampaignBannerMapState {
  DEFAULT,
  ENABLE,
  DISABLE,
  BEFORE_START_TIME,
  AFTER_END_TIME,
  IN_PROGRESS
}

export type ChildCreative = {
  creativeId: number;
  name: string;
  creativeType: CreativeType;
  state: CreativeStatus;
  updateTime: string;
  approvalStatus: { [adxName: string]: { state: number; udt: string } };
  creativeValues: {
    product: {
      productId: number | string;
      name: string;
      imgLink: string;
      adServingUrl?: string;
      availability?: ProductAvailability;
      multipack?: number;
    };
    images: {
      imageUrl: string;
      w: number;
      h: number;
    }[];
  };
};

export type CreativeRelatedProductInfo = {
  id: string;
  name: string;
  imgLink: string;
  adServingUrl?: string;
  availability?: ProductAvailability;
  multipack?: number;
  creativeId: number;
  creativeType: CreativeType;
  state: CreativeStatus;
  approvalStatus: { [adxName: string]: { state: number, udt: string } };
  updateTime?: string;
};

export type CreativeListRecord = {
  advertiserId: number,
  approvalStatus: { [adxName: string]: { state: number, udt: string } },
  bannerImageUrl: string | null,
  bannerUrl: string,
  bindingCampaign: BindingCampaign[],
  bindingCount: { enable: number, disable: number },
  createTime: string,
  creativeId: number,
  state: CreativeStatus, // 素材狀態
  creativeState: CreativeStatus, // 綁定狀態
  creativeType: CreativeType,
  creativeValues: { [key: string]: string | number | boolean | object },
  name: string,
  tenmaxCategory: string,
  origTenmaxCategory: string | null,
  bannerExtra?: { [key: string]: string | number | boolean | object },
  duration?: number,
  retail?: string,
  product?: {
    productId: number | string;
    name: string;
    imgLink: string;
    adServingUrl?: string;
    availability?: ProductAvailability;
    multipack?: number;
  };
  updateTime?: string;
  relatedProductInfo?: CreativeRelatedProductInfo[];
};

export enum CreativeType {
  IMAGE = 1,
  PRODUCT_NATIVE = 9,
  RICH_PRODUCT_NATIVE = 12,
  WEB_RICH_PRODUCT_NATIVE,
  BRAND_LED,
  SITE_WIDE_RECOMMENDED,
  PERSONALIZED_GOLDEN_RECOMMENDED,
  RICH_MEDIA
}

// Rich Media 送審端的 template ID（PCH-202：先 hardcode，不做管理頁面）。
// 上稿表單、送審 payload 與各預覽元件共用同一份，避免字面值散落各處。
export enum RichMediaTemplateId {
  EXPAND_IMAGE = 'EXPAND_IMAGE_BANNER_1',
  EXPAND_VIDEO = 'EXPAND_VIDEO_BANNER_1',
  MARQUEE_PC = 'MARQUEE_BANNER_PC',
  MARQUEE_MOBILE = 'MARQUEE_BANNER_MOBILE'
}

// creative 的素材內容在不同 API 回應中命名不一（creativeValue / creativeValues），
// 且型別上是物件但實際可能是後端回傳的 JSON 字串，故統一在這裡收斂。
export const parseCreativeValue = (creative: any): any => {
  const raw: unknown = creative?.creativeValue ?? creative?.creativeValues;
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw);
    } catch {
      return {};
    }
  }
  return raw || {};
};

export type CreativeValue = {
  w?: number;
  h?: number;
  imageUrl?: number;
  title?: string;
  desc?: string;
  img?: ImageData;
  img_l?: ImageData;
  img_s?: ImageData;
  icon?: ImageData;
  icon_l?: ImageData;
  icon_s?: ImageData;
};

export type ImageData = {
  url: string;
  w: number;
  h: number;
};

export enum CreativeStatus {
  'STATUS',
  'ACTIVE',
  'DEACTIVE',
  'DELETED'
}

export enum ApprovalStatus {
  'NEW',
  'PENDING',
  'APPROVED',
  'DENIED',
  'FIXED',
  'INCOMPLETED',
  'DELETED'
}

export enum ADX {
  asiamax = 'rmn'
}
